import URLSearchParams from 'url-search-params';
/**
 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
 * @returns {object} Meta Object
 */
export const getPageMeta = () => {
	let data = {};
	let metaEl = document.querySelector('[fs-prop="analytics"]');
	if( ! metaEl ) return data;
	let atts = metaEl.attributes;
	for (let i=0,len=atts.length;i<len;i++) {
		if (atts[i].value != null) {
			let att = atts[i].name;
			let val = atts[i].value;

			att = (att.indexOf('-') >= 0) ? att.replace(/-/g, '_') : att;
			data[att] = val.trim();
		}
	}

	return data;
}

// query string helpers
export const setCampaignTraitsSession = () => {
	if (window.location.search.length == 0) return;

	const queryStr = window.location.search;
	const campaignTraits = {
		"org": "campaign_organization",
		"ag": "campaign_agency",
		"mc": "campaign_type",
		"src": "campaign_source",
		"cmp": "campaign_name",
		"add": "campaign_additional",
		"cmpid": "campaign_tracking_code"
	};	
	const query = new URLSearchParams(queryStr);
	const params = Object.keys(campaignTraits);
	let result;

	for (let key of query.keys()) {
		if (params.includes(key)) {
			if (!result) result = {};
			
			result[campaignTraits[key]] = query.get(key);
		}
	}

	if (result) {
		window.sessionStorage.setItem('sessionCampaignTraits', JSON.stringify(result));
	}

	return result;
};

export const getSessionCampaignTraits = () => {
	let result;

	try {
		result = JSON.parse(window.sessionStorage.getItem('sessionCampaignTraits'));
		if (!result) {
			result = setCampaignTraitsSession();
		}
	} catch (e) {
		return;
	}

	return result;
};

/*
`lastAnonymousProfileId`
 + populate when user hasn't logged in
 + pass blank on tracking when user is logged in
 + pass last anon id if user is logged out (?)

`lastKnownProfileId`
 + pass blank when user hasn't logged in
 + populate when user logs out
 + pass blank when user logs back in (?)
*/
export const getProfileData = (objData) => {
	if (window.wisRegistration) {
		const wisReg = window.wisRegistration;
		let isLoggedIn = wisReg.isUserLoggedIn();
		if (isLoggedIn) {
			let profileId = wisReg.getProfileId();

			objData.dcg_profile_id = (profileId != null && !isObjectEmpty(profileId)) ? profileId : null;
			if (objData.dcg_profile_id != null) sessionStorage.setItem('lastKnownProfileId', profileId);
		} 
		objData.lastKnownProfileId = sessionStorage.getItem('lastKnownProfileId');
		objData.lastAnonymousProfileId = wisReg.getAnonProfileId() || sessionStorage.getItem('lastAnonymousProfileId');
		
		sessionStorage.setItem('lastAnonymousProfileId', objData.lastAnonymousProfileId);
	}
	return objData;
}

export const convertSecondsToTime = (secs) => {
	const sec_num = parseInt(secs, 10);
	const hours   = Math.floor(sec_num / 3600) % 24;
	const minutes = Math.floor(sec_num / 60) % 60;
	const seconds = sec_num % 60;
	const timeArr = (hours > 0) ? [hours,minutes,seconds] : [minutes,seconds];

	return timeArr.map((v, i) => (!v < 10 ? (i != 0 ? "0" + v : v) : v ))
	.filter((v,i) => v !== "00" || i > 0)
	.join(":");	
}

export const isObjectEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}